<script lang="ts">
  import { Clock } from '@lucide/vue';
  import { CheckCircle2 } from '@lucide/vue';

  export default {
    name: 'ActivityIndicator',
    components: {
      Clock,
      CheckCircle2
    }
  };
</script>

<script setup lang="ts">
  import { computed } from 'vue';
  import { DateTime } from 'luxon';

  const props = defineProps<{
    lastActiveDate: Date | string;
  }>();

  const strokeWidth = 2;
  const strokeOpacity = 0.2;
  const stroke = 'black';

  const lastActiveDate = computed(() => {
    return new Date(props.lastActiveDate);
  });

  const tooltip = computed(() => {
    return DateTime.fromJSDate(lastActiveDate.value).toLocaleString(DateTime.DATETIME_FULL);
  });

  const displayDate = computed(() => {
    const diff = DateTime.now().diff(DateTime.fromJSDate(lastActiveDate.value), ['minutes', 'hours', 'days', 'weeks']);
    
    if (Math.floor(diff.weeks) > 0) {
      return DateTime.fromJSDate(lastActiveDate.value).toLocaleString(DateTime.DATE_SHORT);
    }
    if (Math.floor(diff.days) > 0) {
      return Math.floor(diff.days) + ' day' + (Math.floor(diff.days) > 1 ? 's' : '') + ' ago';
    }
    if (Math.floor(diff.hours) > 0) {
      return Math.floor(diff.hours) + ' hour' + (Math.floor(diff.hours) > 1 ? 's' : '') + ' ago';
    }
    if (Math.floor(diff.minutes) > 0) {
      return Math.floor(diff.minutes) + ' minute' + (Math.floor(diff.minutes) > 1 ? 's' : '') + ' ago';
    }

    return 'Active';
  });

  const isActive = computed(() => {
    return lastActiveDate.value > DateTime.now().minus({ minutes: 5 }).toJSDate();
  });
</script>

<template>
  <div class="tooltip tooltip-bottom flex flex-row w-fit-content justify-between items-center" :data-tip="tooltip">
    <div class="scale-[60%] flex">
      <!-- @vue-skip -->
      <CheckCircle2
        v-if="isActive"
        fill="#04cf0b"
        :stroke-width="strokeWidth"
        :stroke="stroke"
        :stroke-opacity="strokeOpacity"
      />
  
      <!-- @vue-skip -->
      <Clock
        v-else
        fill="#ffe278"
        :stroke-width="strokeWidth"
        :stroke="stroke"
        :stroke-opacity="strokeOpacity"
      />
    </div>

    <div class="text-[8pt] font-medium">{{ displayDate }}</div>
  </div>
</template>
